import { render, staticRenderFns } from "./ModalNomenclaturaDuplicada.vue?vue&type=template&id=a501a918"
import script from "./ModalNomenclaturaDuplicada.vue?vue&type=script&lang=ts"
export * from "./ModalNomenclaturaDuplicada.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports